// extracted by mini-css-extract-plugin
module.exports = {"sketch":"SummaryInfo_sketch__14csY","damage":"SummaryInfo_damage__2VeCW"};